function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "museum-building-svgrepo-com",
  transform: "translate(0 -24.381)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_3256",
  "data-name": "\\uADF8\\uB8F9 3256",
  transform: "translate(0 41.315)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_3255",
  "data-name": "\\uADF8\\uB8F9 3255",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_495",
  "data-name": "\\uD328\\uC2A4 495",
  d: "M22.773,380.241v-2.336H1.752v2.336H0v2.92H24.524v-2.92Z",
  transform: "translate(0 -377.905)",
  fill: "#777"
}))), /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_3258",
  "data-name": "\\uADF8\\uB8F9 3258",
  transform: "translate(10.51 32.556)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_3257",
  "data-name": "\\uADF8\\uB8F9 3257",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\uC0AC\\uAC01\\uD615_2497",
  "data-name": "\\uC0AC\\uAC01\\uD615 2497",
  width: 3.503,
  height: 7.007,
  fill: "#777"
}))), /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_3260",
  "data-name": "\\uADF8\\uB8F9 3260",
  transform: "translate(18.101 32.556)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_3259",
  "data-name": "\\uADF8\\uB8F9 3259",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\uC0AC\\uAC01\\uD615_2498",
  "data-name": "\\uC0AC\\uAC01\\uD615 2498",
  width: 3.503,
  height: 7.007,
  fill: "#777"
}))), /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_3262",
  "data-name": "\\uADF8\\uB8F9 3262",
  transform: "translate(2.92 32.556)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_3261",
  "data-name": "\\uADF8\\uB8F9 3261",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\uC0AC\\uAC01\\uD615_2499",
  "data-name": "\\uC0AC\\uAC01\\uD615 2499",
  width: 3.503,
  height: 7.007,
  fill: "#777"
}))), /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_3264",
  "data-name": "\\uADF8\\uB8F9 3264",
  transform: "translate(0 24.381)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_3263",
  "data-name": "\\uADF8\\uB8F9 3263",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_496",
  "data-name": "\\uD328\\uC2A4 496",
  d: "M12.262,24.381,0,28.468V30.8H24.524V28.468Z",
  transform: "translate(0 -24.381)",
  fill: "#777"
}))));

function SvgArtistShowcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.524,
    height: 22.189,
    viewBox: "0 0 24.524 22.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistShowcase);
export default __webpack_public_path__ + "static/media/artist-showcase.129a4160.svg";
export { ForwardRef as ReactComponent };